import httpClient from "@/apis/base/httpclient";
import api from "@/apis/system/organizationAPI.js";
import Crud from "@/stores/crudBase";
import commonFn from '@/commons/commonFunction';
import { MSEnum } from '@/commons/enumeration';

var crud = new Crud("Organization", api);

const state = {
  ...crud.state,

  _config: {
    field: {
      key: "OrganizationUnitID",
      name: "OrganizationUnitName",
    },
  },
  datas: [],
  treeItems: [],
  OrganizationLevel2: [],
  treeForSetting: [],
  OrganizationLevel3: [],
  departmentList: [],
  treeForList: [],
  treeTotalData: 0,
  organizationList: [],
  organizationUnitList: [],
};

const getters = {
  ...crud.getters,
};

/**
 * Chứa các hàm action
 * VDGiang 11/10/2022
 */
const actions = {
  ...crud.actions,

  /**
   * VDGiang 11/10/2022
   * Lấy thông tin đơn vị theo ID
   * @param {*} context
   * @param {*} payload
   * @returns
   */
  getOrganizationByID: async function (context, payload) {
    context.commit("updateLoading", true);
    let request = {
      url: api.getAPIUrl() + "/edit/" + payload,
    }
    try {
      let res = await httpClient.getAsync(request);
      return res;
    } catch (err) {
      console.error(err);
    } finally {
      context.commit("updateLoading", false);
    }
  },


  /**
   * VDGiang 11/10/2022
   * Cập nhật thông tin đơn vị
   * @param {*} context
   * @param {*} payload
   * @returns
   */
  async update(context, payload) {
    let request = {
      url: api.getAPIUrl() + "",
      data: payload
    }
    context.commit("updateLoading", true);

    let res = await httpClient.putAsync(request);

    context.commit("updateLoading", true);

    if (res.Data) {
      //cập nhật danh sách
      context.commit("updateItem", res.Data);
    }

    return res;
  },

  /**
   * Load danh sách
   * VDGiang 11/10/2022
   */
  async getOrganizationLevel2(context, payload) {

    let res = await api.getListTreeByParent(payload || {});

    if (res) {
      res.payload = payload;
      context.commit("setAllOrganizationLevel2", res);
    }

    return res;
  },

  /**
   * Lấy form đơn vị mới
   * VDGiang 11/10/2022
   */
   async getNewOrganization(context, payload) {

    let res = await api.getNewOrganization(payload || {});

    return res;
  },

  /**
   * Load danh sách
   * VDGiang 11/10/2022
   */
  async loadListTreeSetting(context, payload) {
    let res = await api.getListTreeByParent(payload || {});
    if (res) {
      res.payload = payload;
      context.commit("setTreeForSetting", res);
    }

    return res;
  },

  /**
  * Load danh sách thông tin đơn vị cấp 3
  * VDGiang 11/10/2022
   */
  async getOrganizationLevel3(context, payload) {
    let res = await api.getListTreeByParent(payload || {});

    if (res) {
      res.payload = payload;
      context.commit("setAllOrganizationLevel3", res);
    }

    return res;
  },

  /**
   * cập nhật thứ tự cây đơn vị
   * @param {*} context
   * @param {*} payload
   * @returns
   * VDGiang 11/10/2022
   */
  async updateSortOrder(context, payload) {
    context.commit("updateLoading", true);

    let res = await api.updateSortOrder(payload || {});
    context.commit("updateLoading", false);

    if (res) {
      res.payload = payload;
      context.commit("", res.Data);
    }
    return res
  },

  /**
  * Load danh sách phòng ban
  * VDGiang 11/10/2022
  */
  async getDepartmentInOrgUnit(context, payload) {
    context.commit("updateLoading", true);

    let res = await api.getDepartmentInOrgUnit(payload || {});
    context.commit("updateLoading", false);

    if (res) {
      res.payload = payload;
      context.commit("setDepartmentDataForOrgUnit", res.Data);
    }

    return res;
  },


  /**
  * Load danh sách org unit active
  * VDGiang 11/10/2022
  */
  async getAllOrgUnitActive(context, payload) {
    context.commit("updateLoading", true);

    //let res = await api.getAllOrgUnitActive(payload || {});
    let res = await api.getListTreeByParent(payload || {});
    context.commit("updateLoading", false);

    if (res) {
      res.payload = payload;
      context.commit("setOrgUnitActive", res);
    }

    return res;
  },

  /**
   * lấy danh sách cơ cấu tổ chức theo node cha
   * @param {any} context
   * @param {any} payload
   * VDGiang 11/10/2022
   */
  async getListTreeByParent(context, payload) {
    context.commit("updateLoading", true);

    let res = await api.getListTreeByParent(payload || {});
    context.commit("updateLoading", false);

    if (res) {
      res.payload = payload;
      context.commit("setTreeForList", res);
    }

    return res;
  },

  /**
   * hàm validate dữ liệu trên server
   * @param {} context
   * @param {*} payload
   * @returns
   * VDGiang 11/10/2022
   */
  async validate(context, payload) {
    let res = await api.validate(payload || {});

    if (res) {
      res.payload = payload;
    }

    return res;
  },

  /**
  * Lưu thông tin đơn vị
  * VDGiang 11/10/2022
  */
  async updateTenantInfor(context, payload) {
    context.commit("updateLoading", true);
    let res = await api.updateTenantInfor(payload || {});
    context.commit("updateLoading", false);

    if (res) {
      res.payload = payload;
    }

    return res;
  },
};

const mutations = {
  ...crud.mutations,

  setOrganizations(state, orgs) {
    state.organizationUnitList = orgs;
  },

  setAllItems(state, res) {
    state.treeItems.removeAll();
    state.treeItems.append(res);
  },

  setAllOrganizationLevel2(state, res) {
    if (!res.payload) {
      state.OrganizationLevel2.removeAll();
    }
    state.OrganizationLevel2.append(res.OrganizationUnitDetail);
  },

  setTreeForSetting(state, res) {
    if (res) {

      state.treeForSetting.append(res.OrganizationUnitDetail);
    }

  },

  setAllOrganizationLevel3(state, res) {
    if (!res.payload) {
      state.OrganizationLevel3.removeAll();
    }

    if (res.Data && res.Data.Result && res.Data.Result.PageData && res.Data.Result.PageData.length > 0) {
      res.Data.Result.PageData.forEach((i) => {
        i.OrganizationID = i.OrganizationUnitID;
        i.OrganizationName = i.OrganizationUnitName;
      })
      state.OrganizationLevel3.append(res.Data.Result.PageData);
    }
  },

  setDepartmentDataForOrgUnit(state, res) {
    state.departmentList.removeAll();
    state.departmentList.append(res);
  },

  setOrgUnitActive(state, res) {
    if (!res.payload) {
      state.organizationList.removeAll();
    }

    state.organizationList.append(res.Data.Result.PageData);
  },

  setTreeForList(state, res) {
    res.OrganizationUnitDetail.forEach(item => {
      if (state.treeForList.findIndex(it => it.OrganizationUnitID == item.OrganizationUnitID) == -1)
        state.treeForList.push(item);
    })
    state.treeTotalData = res.OrganizationUnitDetail.length;
  },

  /**
  * Cập nhật khi xóa bản ghi
  * VDGiang 11/10/2022
  */
  deleteItems(state, items) {
    let keyField = state._config.field.key;

    if (keyField && items) {
      let count = items.length;
      if (Array.isArray(items)) {

        for (let k = 0; k < count; k++) {
          let id = items[k][keyField];
          for (let i = 0; i < state.treeForList.length; i++) {
            let item = state.treeForList[i];

            if (item[keyField] === id) {
              state.treeForList.remove(item);
              break;
            }
          }
        }
      } else if (typeof (items) == "object") {
        let id = items[keyField];
        for (let i = 0; i < state.treeForList.length; i++) {
          let item = state.treeForList[i];

          if (item[keyField] === id) {
            state.treeForList.remove(item);
            break;
          }
        }
      }

      state.total -= count;
    }

    //xóa cache combobox data
    if (state.cacheKeys) {
      commonFn.removeCacheComboboxData(state.cacheKeys);
    }
    state.version++;
  },

  /**
  * Cập nhật khi sửa bản ghi
  * VDGiang 11/10/2022
  */
  updateItem(state, data) {
    let keyField = state._config.field.key;
    let newItem = { ...data };

    if (keyField) {
      let id = data[keyField];
      let departmentId = data.Departments.map(function (e) { return e[keyField] });
      let changeMaster = false;
      for (let i = 0; i < state.treeForList.length; i++) {
        let item = state.treeForList[i];

        if (item.MISACode.indexOf(data.MISACode) == 0) {
          item.Inactive = data.Inactive;
        }

        if (item[keyField] === id) {
          Object.assign(item, data);
          state.treeForList.remove(item);
          state.treeForList.insertAt(i, data);
          changeMaster = true;
          //break;
        }
        else if (departmentId.includes(item[keyField])) {
          var departmentItem = data.Departments.find(function (e) { return e[keyField] == item[keyField] });

          Object.assign(item, departmentItem);
          state.treeForList.remove(item);

          // Nếu phòng ban có trạng thái là xóa thì không thêm vào cây CCTC nữa
          if (departmentItem?.State !== MSEnum?.ModelState?.Delete || departmentItem?.State !== MSEnum?.ModelState?.Delete) {
            state.treeForList.insertAt(i, departmentItem);
          }

          departmentId.remove(item[keyField]);
        }
      }

      if (departmentId && departmentId.length > 0) {

        for (let i = 0; i < departmentId.length; i++) {
          var newDeparment = data.Departments.find(function (e) { return e[keyField] == departmentId[i] });

          state.treeForList.insertAt(state.treeForList.length, newDeparment);
          state.total += 1;
        }
      }
    }

    //xóa cache combobox data
    if (state.cacheKeys) {
      commonFn.removeCacheComboboxData(state.cacheKeys);
    }
    state.version++;
  },

  /**
  * Cập nhật khi thêm bản ghi
  * VDGiang 11/10/2022
  */
  insertItem(state, data) {
    let newItem = { ...data };

    if (newItem.ExtData) {
      let ext = JSON.parse(newItem.ExtData);
      for (let i in ext) {
        newItem[i] = ext[i];
      }
    }

    var parentItem = state.treeForList.find(function (item) {
      return item.OrganizationUnitID == newItem.ParentID
    });

    if (parentItem) {
      state.treeForList.insertAt(state.treeForList.length, newItem);
      state.total += 1;
    }


    state.empty = false;

    //xóa cache combobox data
    if (state.cacheKeys) {
      commonFn.removeCacheComboboxData(state.cacheKeys);
    }
    state.version++;
  },


};

export default {
  debug: process.env.NODE_ENV !== "production",
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
